import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BarcodeScannerLivestreamComponent } from 'ngx-barcode-scanner';
import { MessageService } from 'primeng/api';
import { OpsappService } from '../../services/opsapp.service';

@Component({
  selector: 'app-worklist-list',
  templateUrl: './worklist-list.component.html',
  styleUrls: ['./worklist-list.component.css']
})
export class WorklistListComponent {

  @ViewChild(BarcodeScannerLivestreamComponent)
  barcodeScanner: BarcodeScannerLivestreamComponent;

  showScanner: boolean = false;
  scannerLoading: boolean = false;
  startDate: Date | undefined;
  endDate: Date | undefined;

  barcodeValue: any;
  worklists: any[] = new Array;
  loading: boolean = true;

  constructor(private opsappService: OpsappService, 
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService){}

  ngOnInit() {
    const barcode = this.route.snapshot.paramMap.get('barcode');
    if (barcode != undefined && barcode != null)
      this.barcodeValue = barcode;
    this.loadWorklists();
  }

  loadWorklists(){
    this.loading = true;
    if (this.barcodeValue)
      this.barcodeValue = this.barcodeValue.trim();

    var worklistListOptions = {
       Barcode: this.barcodeValue,
       StartDate: this.startDate,
       EndDate: this.endDate
    }

    this.opsappService.getWorklistList(worklistListOptions).then(data => {
      this.worklists = data;
      this.loading = false;
    });
    
    //this.worklists.push({name: "worklist1", time: Date.now()});
    //this.worklists.push({name: "worklist2", time: Date.now()});
  }

  onValueChanges(result: any) {
    this.barcodeValue = result.codeResult.code;
    this.showScanner = false;
    this.barcodeScanner.stop();
  }

  onStarted(started: any) {
    this.scannerLoading = false;
    console.log(started);
  }

  OpenScanner(){
    this.showScanner = true;
    this.scannerLoading = true;
    this.barcodeScanner.start();
  }
  CloseScanner(){
    this.barcodeScanner.stop();
    this.showScanner = false;
  }

  openWorklist(worklist: any){
    if (this.barcodeValue)
      this.barcodeValue = this.barcodeValue.trim();
    
    worklist.searchedBarcode = this.barcodeValue;
    this.opsappService.activeWorklist.next(worklist);
    this.router.navigate(["worklist"], { relativeTo: this.route.parent })
  }

  Search(){
    this.loadWorklists();
  }
  
  Clear(){
    this.barcodeValue = null;
    this.startDate = null;
    this.endDate = null;
    this.loadWorklists();
  }

  ClearEnabled(){
    return (this.barcodeValue != null || this.startDate != null || this.endDate != null)
  }
}
